import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WondeSyncState } from './wonde-sync.state';

export const selectWondeSyncState = createFeatureSelector<WondeSyncState>('wondeSync');

export const selectWondeSyncMismatches = createSelector(
  selectWondeSyncState,
  (state) => state.mismatches
);

export const selectWondeSyncSkippedMismatches = createSelector(
  selectWondeSyncState,
  (state) => state.skippedMismatches
);

export const selectWondeSyncSkippedError = createSelector(
  selectWondeSyncState,
  (state) => state.skippedError
);

export const selectWondeSyncLoading = createSelector(
  selectWondeSyncState,
  (state) => state.loading
);

export const selectWondeSyncError = createSelector(
  selectWondeSyncState,
  (state) => state.error
);

export const selectWondeSyncActionInProgressId = createSelector(
  selectWondeSyncState,
  (state) => state.actionInProgressId
);

/** Drives the "Review mismatches" badge on the MIS integration page. */
export const selectWondeSyncPendingCount = createSelector(
  selectWondeSyncMismatches,
  (mismatches) => mismatches.length
);
